import React from "react"
import Link from "gatsby-link"
import Helmet from "react-helmet"

import Step1 from '../recovery/Step1';
import Step2 from '../recovery/Step2';
import Complete from '../forgot/Complete';

import Navigation from '../layouts/navigation.js'
import Footer from '../layouts/footer.js'

import register_now from '../img/register-now-left.svg'

import { Route } from "react-router-dom"

class RecoveryFormStep1 extends React.Component {

	constructor(props) {
		super(props);
		this._nextStep = this._nextStep.bind(this);
		this._prevStep = this._prevStep.bind(this);
		this._setStep1 = this._setStep1.bind(this);
		this._setStep2 = this._setStep2.bind(this);
		this.state = {
			step: 1,
			email: '',
			hash: '',
			error: '',
			hasHash: false
		};
	}

	_getCurrentStep() {
		switch (this.state.step) {
			case 1:
				return <Step1 
					message={"The recovery link has been sent to the e-mail address you have indicated. Please, follow the link e-mailed or enter the verification code manually. Please note that it can take some time for the e-mail to arrive."}
					error={this.state.error}
					setData={ this._setStep1 }
					nextStep={ this._nextStep } />;
			case 2:
				return <Step2 
					hash={this.state.hash}
					hasHash={this.state.hasHash}
					setData={ this._setStep2 }
					prevStep={ this._prevStep }
					nextStep={ this._nextStep } />;
			case 3:
				return <Complete />;

			default:
				throw 'Invalid Step';
		}
	}
	_nextStep() {
		this.setState({step: this.state.step + 1});
	}
	_prevStep() {
		this.setState({step: this.state.step - 1});
	}
	_setStep1(e) {
		this.setState({ email: e.state.email });
		this.setState({ hash: e.state.hash });
	}
	_setStep2(e) {
		this.setState({ error: e.state.error });
	}

	render() {
		return <div>{ this._getCurrentStep.call(this) }</div>
	}
}

class RecoveryFormStep2 extends React.Component {
	constructor(props) {
		super(props);
		this._nextStep = this._nextStep.bind(this);
		this._prevStep = this._prevStep.bind(this);
		this._setStep1 = this._setStep1.bind(this);
		this._setStep2 = this._setStep2.bind(this);
		this.state = {
			step: 2,
			hash: (props.match.params.emailhash).replace('.html',''),
			error: '',
			hasHash: true
		};
	}

	_getCurrentStep() {
		switch (this.state.step) {
			case 1:
				return <Step1 
					message={"The recovery link has been sent to the e-mail address you have indicated. Please, follow the link e-mailed or enter the verification code manually. Please note that it can take some time for the e-mail to arrive."}
					error={this.state.error}
					setData={ this._setStep1 }
					nextStep={ this._nextStep } />;
			case 2:
				return <Step2 
					hash={this.state.hash}
					hasHash={this.state.hasHash}
					setData={ this._setStep2 }
					prevStep={ this._prevStep }
					nextStep={ this._nextStep } />;
			case 3:
				return <Complete />;

			default:
				throw 'Invalid Step';
		}
	}
	_nextStep() {
		this.setState({step: this.state.step + 1});
	}
	_prevStep() {
		this.setState({step: this.state.step - 1});
	}
	_setStep1(e) {
		this.setState({ email: e.state.email });
		this.setState({ hash: e.state.hash });
	}
	_setStep2(e) {
		this.setState({ error: e.state.error });
	}

	render() {
		return <div>{ this._getCurrentStep.call(this) }</div>
	}
}

export default class Recovery extends React.Component {

	pageClick(e) {
		document.getElementsByTagName('body')[0].className=''
	}

	componentDidMount() {
		var self = this, mask = document.getElementById('mask');
		mask.addEventListener('touchstart', self.pageClick, false);
	}

	render() {

		return (
			<div>

				<Helmet
					title="Remote academic writers needed. Freelance job for retired, students, teachers and freelance writers - UvoCorp.com"
					meta={[
						{ name: "description", content: "Online Freelance Writing Jobs, Freelance Writer Needed, Jobs for Writers" },
						{ name: "robots", content: "noindex,nofollow"},
					]}
					link={[
						{ rel: 'canonical', href: "https://www.uvocorp.com/recovery_password/" }
					]} />

				<div className='header' id="header">
					<Navigation />
				</div>

				<div className="wrapper">
				
					<div className="inner-white">
						<div className="container">

							<div className="form-container recovery">
								<h1 className="form-header">Recovery password</h1>
								<div className="form-wrapper" id="forgotFormContainer">
									<Route exact path="/recovery_password" component={RecoveryFormStep1}/>
									<Route path="/recovery_password/:emailhash" component={RecoveryFormStep2}/>
								</div>
							</div>

						</div>
					</div>

					<div className="inner-registration inner-registration-left">
						<div className="container">
							<div className="inner-registration-image">
								<div className="img inner-registration-img">
									<img src={register_now} alt="Start registration"/>
								</div>
							</div>
							<div className="inner-registration-text">
								<div className="inner-registration-title">Register now <br />to start earning!</div>
								<div className="inner-registration-button">
									<Link to="/register_email.html">Start registration</Link>
								</div>
							</div>
						</div>
					</div>

					<Footer />

				</div>
				<div id="mask" className="c-mask"></div>

			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/pages/recovery_password.js